module.exports = __webpack_public_path__ + "static/media/pdf_icon.5a9681c8.svg";